import { CommonModule, KeyValuePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import {
  AiAssignmentConstraintForm,
  AiConstraintsForm,
  CONSTRAINT_CONFIG,
} from '../../../core/forms/ai-constraints.form';

@Component({
  selector: 'ai-constraints-field',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    TranslateModule,
    GalaxyFormFieldModule,
    GalaxyTooltipModule,
    KeyValuePipe,
  ],
  templateUrl: './ai-constraints-field.component.html',
  styleUrl: './ai-constraints-field.component.scss',
})
export class AiConstraintsFieldComponent {
  private translate = inject(TranslateService);

  constraintsForm = input.required<AiConstraintsForm>();

  assistantNamespaceTypes = CONSTRAINT_CONFIG.assistantNamespaceTypes;
  assistantTypes = CONSTRAINT_CONFIG.assistantTypes;

  addAssignmentConstraint(): void {
    this.constraintsForm()?.addAssignmentConstraint();
  }

  removeAssignmentConstraint(index: number): void {
    this.constraintsForm()?.removeAssignmentConstraint(index);
  }

  // Handle scope type changes to set appropriate default values
  onScopeTypeChange(index: number, scopeType: string): void {
    const constraintForm = this.constraintsForm()?.controls.assignmentConstraints.at(
      index,
    ) as AiAssignmentConstraintForm;
    if (constraintForm) {
      if (scopeType === 'assistantNamespaceType') {
        constraintForm.controls.scopeValue.setValue(1);
      } else if (scopeType === 'assistantType') {
        constraintForm.controls.scopeValue.setValue(1);
      }
    }
  }
}
